import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import { memo } from 'react';

var _templateObject;
var StyledLabel = styled('label')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  user-select: none;\n  min-height: 1rem;\n  z-index: 1;\n  height: ", ";\n  width: ", ";\n  input {\n    cursor: pointer;\n    opacity: 0;\n    position: absolute;\n    height: 1rem;\n    width: 1rem;\n    left: 0;\n    + span {\n      + span {\n        box-shadow: '0 0 10px red';\n      }\n    }\n    /* Show the selected state when checked */\n    ", "\n    /* Grey out when disabled */\n    &:checked[disabled] + span {\n      opacity: 0.3;\n    }\n    &[disabled] > span {\n      opacity: 0.3;\n      background-color: grey;\n    }\n    /* While Focused - Surround Inner circle with box shadow (Only visible when selected due to opacity rules) */\n    ", "\n    /* While Focused -Surround Outer circle with border & box shadow */\n    &:focus + span + span {\n      outline: none;\n      border: solid 2px ", ";\n      box-shadow: ", ";\n    }\n  }\n"])), function (_ref) {
  var hideLabel = _ref.hideLabel;
  return hideLabel ? '1rem' : undefined;
}, function (_ref2) {
  var hideLabel = _ref2.hideLabel;
  return hideLabel ? '1rem' : undefined;
}, function (_ref3) {
  var theme = _ref3.theme,
    type = _ref3.type;
  return type === 'button' ? "\n      &:checked + span {\n        border: 3px solid ".concat(theme.palette.primary, ";\n        box-shadow: ").concat(theme.palette.primaryLight, " 0px 2px 4px;\n      }\n      &:hover + span {\n        box-shadow: ").concat(theme.palette.grayLighter, " 0px 2px 4px;\n      }\n    ") : " \n      &:checked + span {\n        opacity: 1;\n      }\n    ";
}, function (_ref4) {
  var theme = _ref4.theme,
    type = _ref4.type,
    error = _ref4.error;
  return type === 'button' ? "\n      &:focus + span {\n        border-color:  ".concat(!!error ? theme.palette.error : theme.palette.primary, ";\n        box-shadow: ").concat(!!error ? "0 0 3px ".concat(theme.palette.error) : "".concat(theme.palette.primaryLight, " 0px 2px 4px"), "; \n      }\n    ") : "\n      &:focus + span {\n        border-color: ".concat(!!error ? theme.palette.error : theme.palette.secondary, ";\n        box-shadow: ").concat(!!error ? "0 0 3px ".concat(theme.palette.error) : theme.boxShadow.buttonFocus, ";\n      }\n    ");
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.secondary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.boxShadow.buttonFocus;
});
StyledLabel.defaultProps = {
  theme: themes["default"],
  hideLabel: false,
  error: undefined
};
var RadioLabel = /*#__PURE__*/memo(StyledLabel);

export default RadioLabel;
